<template>
  <div class="home-cards-with-content">
    <div class="content-cards">
      <article>
        <div class="content-card">
          <font-awesome-icon v-bind:icon="$t('serviceOneIcon')" />
          <p>{{ $t('serviceOneTitle') }}</p>
          <p>{{ $t('serviceOneContent') }}</p>
        </div>
      </article>
      <article>
        <div class="content-card">
          <font-awesome-icon v-bind:icon="$t('serviceTwoIcon')" />
          <p>{{ $t('serviceTwoTitle') }}</p>
          <p>{{ $t('serviceTwoContent') }}</p>
        </div>
      </article>
      <article>
        <div class="content-card">
          <font-awesome-icon v-bind:icon="$t('serviceThreeIcon')" />
          <p>{{ $t('serviceThreeTitle') }}</p>
          <p>{{ $t('serviceThreeContent') }}</p>
        </div>
      </article>
    </div>
    <div class="content-block">
      <h3>{{ $t('serviceMainTitle') }}</h3>
      <p>{{ $t('serviceMainLine1') }}</p>
      <p>{{ $t('serviceMainLine2') }}</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HomeCardsWithContent'
  }
</script>
<style scoped lang="scss">
  .home-cards-with-content {
    @apply flex items-center;
    position: relative;
    z-index: 2;

    .content-cards {
      @apply flex flex-wrap w-3/5 pr-2;

      article {
        @apply w-1/2 mb-4 pl-4;
        position: relative;

        .content-card {
          @apply bg-pink p-6 shadow-lg text-white;
          border-bottom-right-radius: 2% 40%;
          border-bottom-left-radius: 2% 40%;
          border-top-right-radius: 2% 40%;
          border-top-left-radius: 2% 40%;

          svg {
            @apply text-4xl ml-2 mb-4;
            float: right;
          }
          p {
            @apply block text-sm pb-2;
            text-shadow: 1px 1px 1px #000;
            &:first-of-type {
              @apply font-bold text-base uppercase;
            }
          }

        }

        &:nth-child(2) {
          position: relative;
          top: 50%;
          transform: translateY(50%);
        }
      }
    }
    .content-block {
      @apply flex-1 pl-8 pr-4 text-right;

      h3 {
        @apply font-medium text-2xl;
        text-shadow: 1px 1px 1px #fff;
      }

      p {
        @apply text-base pt-3 pl-8;
        text-shadow: 1px 1px 1px #fff;
      }
    }

    @screen lg {
      .content-cards {
        article {
          .content-card {
            svg {
              @apply text-3xl;
            }
            p {
              @apply text-sm;
              &:first-of-type {
                @apply text-base;
              }
            }
          }
        }
      }
    }

    @screen md {
      .content-cards {
        @apply pr-0;

        article {
          .content-card {
            svg {
              @apply text-2xl mb-1;
            }
            p {
              @apply text-xs;
              &:first-of-type {
                @apply text-sm;
              }
            }
          }
        }
      }
      .content-block {
        @apply pl-6;

        h3 {
          @apply text-xl;
        }
        p {
          @apply text-sm pt-2 pl-6;
        }
      }
    }

    @screen sm {
      @apply flex-col;
      .content-cards {
        @apply w-full mt-8 pr-4 text-center;
        order: 2;

        article {
          &:nth-child(2) {
            @apply mt-0;
            bottom: 50%;
            top: inherit;
            transform: translateY(50%);
          }

          .content-card {
            @apply p-2 pb-4;
            svg {
              @apply mb-2 text-3xl mt-3;
              float: none;
            }
            p {
              @apply text-xs;
              &:first-of-type {
                @apply text-sm;
              }
            }
          }
        }
      }
      .content-block {
        @apply px-4 pt-6 pb-2 text-center  w-5/6;
        order: 1;
        text-align: center;

        p {
          @apply pl-0 text-sm;
        }
      }
    }
  }
</style>